import type { FC } from "react";

import { ErrorScreen } from "../ErrorScreen/ErrorScreen";
import { BasePage } from "../BasePage/BasePage";

/**
 * The ErrorPage component is the page that displays an error message.
 */
export const ErrorPage: FC = () => {
  return (
    <BasePage variant="marketing">
      <ErrorScreen />
    </BasePage>
  );
};
